module.exports = __webpack_public_path__ + "img/ring_y_i_null_null.301bb8c9.png";